// This file is auto-generated by @hey-api/openapi-ts

import type { Client, ClientMeta, Options as Options2, RequestResult, TDataShape } from './client';
import { client } from './client.gen';
import type { ActivitiesCreateData, ActivitiesCreateErrors, ActivitiesCreateResponses, ActivitiesDeleteData, ActivitiesDeleteErrors, ActivitiesDeleteResponses, ActivitiesListData, ActivitiesListResponses, ActivitiesReorderData, ActivitiesReorderErrors, ActivitiesReorderResponses, ActivitiesUpdateData, ActivitiesUpdateErrors, ActivitiesUpdateResponses, AnalyticsCrossOrgReportData, AnalyticsCrossOrgReportErrors, AnalyticsCrossOrgReportResponses, AnalyticsOrgReportData, AnalyticsOrgReportErrors, AnalyticsOrgReportResponses, AssetsConfirmUploadData, AssetsConfirmUploadErrors, AssetsConfirmUploadResponses, AssetsDeleteData, AssetsDeleteErrors, AssetsDeleteResponses, AssetsListData, AssetsListErrors, AssetsListResponses, AssetsStartUploadData, AssetsStartUploadErrors, AssetsStartUploadResponses, AssetsUpdateData, AssetsUpdateErrors, AssetsUpdateResponses, AuditActionsData, AuditActionsResponses, AuditExportData, AuditExportErrors, AuditExportResponses, AuditListData, AuditListErrors, AuditListResponses, AuditMineData, AuditMineErrors, AuditMineResponses, AuthChangePasswordData, AuthChangePasswordErrors, AuthChangePasswordResponses, AuthForgotPasswordData, AuthForgotPasswordErrors, AuthForgotPasswordResponses, AuthLoginData, AuthLoginErrors, AuthLoginResponses, AuthLogoutData, AuthLogoutResponses, AuthMeData, AuthMeResponses, AuthRefreshData, AuthRefreshResponses, AuthResetPasswordData, AuthResetPasswordErrors, AuthResetPasswordResponses, AuthResetPreviewData, AuthResetPreviewErrors, AuthResetPreviewResponses, AuthUpdateMeData, AuthUpdateMeErrors, AuthUpdateMeResponses, BrandAddCommentData, BrandAddCommentErrors, BrandAddCommentResponses, BrandApproveData, BrandApproveErrors, BrandApproveResponses, BrandConfigsAddContentPillarData, BrandConfigsAddContentPillarErrors, BrandConfigsAddContentPillarResponses, BrandConfigsAddVoicePillarData, BrandConfigsAddVoicePillarErrors, BrandConfigsAddVoicePillarResponses, BrandConfigsCreateForOrgData, BrandConfigsCreateForOrgErrors, BrandConfigsCreateForOrgResponses, BrandConfigsDeleteContentPillarData, BrandConfigsDeleteContentPillarErrors, BrandConfigsDeleteContentPillarResponses, BrandConfigsDeleteData, BrandConfigsDeleteErrors, BrandConfigsDeleteResponses, BrandConfigsDeleteVoicePillarData, BrandConfigsDeleteVoicePillarErrors, BrandConfigsDeleteVoicePillarResponses, BrandConfigsGetData, BrandConfigsGetErrors, BrandConfigsGetResponses, BrandConfigsReorderContentPillarsData, BrandConfigsReorderContentPillarsErrors, BrandConfigsReorderContentPillarsResponses, BrandConfigsReorderVoicePillarsData, BrandConfigsReorderVoicePillarsErrors, BrandConfigsReorderVoicePillarsResponses, BrandConfigsSaveTipSheetData, BrandConfigsSaveTipSheetErrors, BrandConfigsSaveTipSheetResponses, BrandConfigsUpdateContentPillarData, BrandConfigsUpdateContentPillarErrors, BrandConfigsUpdateContentPillarResponses, BrandConfigsUpdateData, BrandConfigsUpdateErrors, BrandConfigsUpdateResponses, BrandConfigsUpdateVoicePillarData, BrandConfigsUpdateVoicePillarErrors, BrandConfigsUpdateVoicePillarResponses, BrandResolveCommentData, BrandResolveCommentErrors, BrandResolveCommentResponses, BrandReviewData, BrandReviewErrors, BrandReviewResponses, BrandTemplatesCreateData, BrandTemplatesCreateErrors, BrandTemplatesCreateResponses, BrandTemplatesDuplicateData, BrandTemplatesDuplicateErrors, BrandTemplatesDuplicateResponses, BrandTemplatesListData, BrandTemplatesListErrors, BrandTemplatesListResponses, DashboardPageSnapshotData, DashboardPageSnapshotErrors, DashboardPageSnapshotResponses, DashboardPillarCoverageData, DashboardPillarCoverageErrors, DashboardPillarCoverageResponses, DashboardRosterData, DashboardRosterErrors, DashboardRosterResponses, DashboardSetupData, DashboardSetupErrors, DashboardSetupResponses, DownloadsFileData, DownloadsFileErrors, DownloadsGetData, DownloadsGetErrors, DownloadsGetResponses, DraftsConfirmPostedData, DraftsConfirmPostedErrors, DraftsConfirmPostedResponses, DraftsCreateData, DraftsCreateErrors, DraftsCreateResponses, DraftsDeleteData, DraftsDeleteErrors, DraftsDeleteResponses, DraftsDiscardPreviewData, DraftsDiscardPreviewErrors, DraftsDiscardPreviewResponses, DraftsGetData, DraftsGetErrors, DraftsGetResponses, DraftsGrowthData, DraftsGrowthResponses, DraftsHistoryData, DraftsHistoryErrors, DraftsHistoryResponses, DraftsListData, DraftsListResponses, DraftsPostingSummaryData, DraftsPostingSummaryErrors, DraftsPostingSummaryResponses, DraftsPreviewPostData, DraftsPreviewPostErrors, DraftsPreviewPostResponses, DraftsUpdateData, DraftsUpdateErrors, DraftsUpdateResponses, FrameworksCreateData, FrameworksCreateErrors, FrameworksCreateResponses, FrameworksDeleteData, FrameworksDeleteErrors, FrameworksDeleteResponses, FrameworksListData, FrameworksListErrors, FrameworksListResponses, FrameworksUpdateData, FrameworksUpdateErrors, FrameworksUpdateResponses, GenerationGenerateMineData, GenerationGenerateMineResponses, GenerationMyMonthData, GenerationMyMonthResponses, HealthLiveData, HealthLiveResponses, HealthReadyData, HealthReadyResponses, HealthWorkerData, HealthWorkerResponses, InvitationsAcceptData, InvitationsAcceptErrors, InvitationsAcceptResponses, InvitationsCreateData, InvitationsCreateErrors, InvitationsCreateResponses, InvitationsListData, InvitationsListErrors, InvitationsListResponses, InvitationsPreviewData, InvitationsPreviewErrors, InvitationsPreviewResponses, InvitationsRevokeData, InvitationsRevokeErrors, InvitationsRevokeResponses, MentionsListData, MentionsListErrors, MentionsListResponses, MentionsMonthData, MentionsMonthErrors, MentionsMonthResponses, MentionsSummaryData, MentionsSummaryErrors, MentionsSummaryResponses, MomentsAddData, MomentsAddErrors, MomentsAddResponses, MomentsArchiveData, MomentsArchiveErrors, MomentsArchiveResponses, MomentsConfirmMediaData, MomentsConfirmMediaErrors, MomentsConfirmMediaResponses, MomentsGetData, MomentsGetErrors, MomentsGetIdeasData, MomentsGetIdeasErrors, MomentsGetIdeasResponses, MomentsGetResponses, MomentsListData, MomentsListErrors, MomentsListResponses, MomentsRemoveMediaData, MomentsRemoveMediaErrors, MomentsRemoveMediaResponses, MomentsRestoreData, MomentsRestoreErrors, MomentsRestoreResponses, MomentsStartMediaUploadData, MomentsStartMediaUploadErrors, MomentsStartMediaUploadResponses, MomentsUpdateData, MomentsUpdateErrors, MomentsUpdateResponses, MonthlyReportsComputeData, MonthlyReportsComputeErrors, MonthlyReportsComputeResponses, MonthlyReportsForMonthData, MonthlyReportsForMonthErrors, MonthlyReportsForMonthResponses, MonthlyReportsMineData, MonthlyReportsMineErrors, MonthlyReportsMineResponses, NotebookArchiveIdeaData, NotebookArchiveIdeaErrors, NotebookArchiveIdeaResponses, NotebookCountsData, NotebookCountsResponses, NotebookIdeasData, NotebookIdeasErrors, NotebookIdeasResponses, NotebookPillarsData, NotebookPillarsResponses, NotebookRestoreIdeaData, NotebookRestoreIdeaErrors, NotebookRestoreIdeaResponses, NotebookUpdateIdeaData, NotebookUpdateIdeaErrors, NotebookUpdateIdeaResponses, OrgsArchiveData, OrgsArchiveErrors, OrgsArchiveResponses, OrgsCreateData, OrgsCreateErrors, OrgsCreateResponses, OrgsExportLinkData, OrgsExportLinkErrors, OrgsExportLinkResponses, OrgsExportsData, OrgsExportsErrors, OrgsExportsResponses, OrgsGetData, OrgsGetErrors, OrgsGetResponses, OrgsListData, OrgsListErrors, OrgsListResponses, OrgsMineData, OrgsMineResponses, OrgsRemoveData, OrgsRemoveErrors, OrgsRemoveResponses, OrgsRestoreData, OrgsRestoreErrors, OrgsRestoreResponses, OrgsRetryExportData, OrgsRetryExportErrors, OrgsRetryExportResponses, OrgsUpdateData, OrgsUpdateErrors, OrgsUpdateResponses, PlansAddEventData, PlansAddEventErrors, PlansAddEventResponses, PlansAddPostData, PlansAddPostErrors, PlansAddPostResponses, PlansByMonthData, PlansByMonthErrors, PlansByMonthResponses, PlansCreateData, PlansCreateErrors, PlansCreateResponses, PlansDeleteData, PlansDeleteErrors, PlansDeleteEventData, PlansDeleteEventErrors, PlansDeleteEventResponses, PlansDeletePostData, PlansDeletePostErrors, PlansDeletePostResponses, PlansDeleteResponses, PlansGenerateEmployeesData, PlansGenerateEmployeesErrors, PlansGenerateEmployeesResponses, PlansGenerateMonthData, PlansGenerateMonthErrors, PlansGenerateMonthResponses, PlansGeneratePageData, PlansGeneratePageErrors, PlansGeneratePageResponses, PlansGetData, PlansGetErrors, PlansGetResponses, PlansListData, PlansListErrors, PlansListResponses, PlansSetPromptsData, PlansSetPromptsErrors, PlansSetPromptsResponses, PlansUpdateData, PlansUpdateErrors, PlansUpdateEventData, PlansUpdateEventErrors, PlansUpdateEventResponses, PlansUpdatePostData, PlansUpdatePostErrors, PlansUpdatePostResponses, PlansUpdateResponses, PromptsAddMineData, PromptsAddMineErrors, PromptsAddMineResponses, PromptsCreateForConfigData, PromptsCreateForConfigErrors, PromptsCreateForConfigResponses, PromptsDeleteForConfigData, PromptsDeleteForConfigErrors, PromptsDeleteForConfigResponses, PromptsDeleteMineData, PromptsDeleteMineErrors, PromptsDeleteMineResponses, PromptsDuplicateMineData, PromptsDuplicateMineErrors, PromptsDuplicateMineResponses, PromptsListForConfigData, PromptsListForConfigErrors, PromptsListForConfigResponses, PromptsMineData, PromptsMineErrors, PromptsMineResponses, PromptsUpdateForConfigData, PromptsUpdateForConfigErrors, PromptsUpdateForConfigResponses, PromptsUpdateMineData, PromptsUpdateMineErrors, PromptsUpdateMineResponses, ReportsConfirmUploadData, ReportsConfirmUploadErrors, ReportsConfirmUploadResponses, ReportsDeleteData, ReportsDeleteErrors, ReportsDeleteResponses, ReportsListData, ReportsListErrors, ReportsListResponses, ReportsStartUploadData, ReportsStartUploadErrors, ReportsStartUploadResponses, SocialPageAnalyticsData, SocialPageAnalyticsErrors, SocialPageAnalyticsResponses, SocialPageConnectData, SocialPageConnectErrors, SocialPageConnectResponses, SocialPageDisconnectData, SocialPageDisconnectErrors, SocialPageDisconnectResponses, SocialPagePostHistoryData, SocialPagePostHistoryErrors, SocialPagePostHistoryResponses, SocialPagePublishPostData, SocialPagePublishPostErrors, SocialPagePublishPostResponses, SocialPageRefreshPagesData, SocialPageRefreshPagesErrors, SocialPageRefreshPagesResponses, SocialPageSelectPagesData, SocialPageSelectPagesErrors, SocialPageSelectPagesResponses, SocialPageSetPrimaryData, SocialPageSetPrimaryErrors, SocialPageSetPrimaryResponses, SocialPageStatusData, SocialPageStatusErrors, SocialPageStatusResponses, SocialPageSyncData, SocialPageSyncErrors, SocialPageSyncResponses, SystemErrorsData, SystemErrorsErrors, SystemErrorsResponses, SystemHealthData, SystemHealthResponses, SystemReportData, SystemReportErrors, SystemReportResponses, TrackerGetData, TrackerGetResponses, TrackerHistoryData, TrackerHistoryResponses, TrackerLessData, TrackerLessErrors, TrackerLessResponses, TrackerPickData, TrackerPickErrors, TrackerPickResponses, TrackerTapData, TrackerTapErrors, TrackerTapResponses, TrackerUndoData, TrackerUndoErrors, TrackerUndoResponses, TrackerUpdateSettingsData, TrackerUpdateSettingsErrors, TrackerUpdateSettingsResponses, UsersCreateData, UsersCreateErrors, UsersCreateResponses, UsersGetData, UsersGetErrors, UsersGetResponses, UsersListData, UsersListErrors, UsersListResponses, UsersUpdateData, UsersUpdateErrors, UsersUpdateResponses, VoiceAddSampleData, VoiceAddSampleErrors, VoiceAddSampleResponses, VoiceDeleteSampleData, VoiceDeleteSampleErrors, VoiceDeleteSampleResponses, VoiceMineData, VoiceMineResponses, VoiceOptionsData, VoiceOptionsResponses, VoiceStageOneData, VoiceStageOneErrors, VoiceStageOneResponses, VoiceStageThreeData, VoiceStageThreeErrors, VoiceStageThreeResponses, VoiceTeamReadinessData, VoiceTeamReadinessErrors, VoiceTeamReadinessResponses, VoiceUpdateSampleData, VoiceUpdateSampleErrors, VoiceUpdateSampleResponses, WebhooksEmailData, WebhooksEmailErrors, WebhooksEmailResponses } from './types.gen';

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean, TResponse = unknown> = Options2<TData, ThrowOnError, TResponse> & {
    /**
     * You can provide a client instance returned by `createClient()` instead of
     * individual options. This might be also useful if you want to implement a
     * custom client.
     */
    client?: Client;
    /**
     * You can pass arbitrary values through the `meta` object. This can be
     * used to access values that aren't defined as part of the SDK function.
     */
    meta?: keyof ClientMeta extends never ? Record<string, unknown> : ClientMeta;
};

/**
 * Live
 */
export const healthLive = <ThrowOnError extends boolean = false>(options?: Options<HealthLiveData, ThrowOnError>): RequestResult<HealthLiveResponses, unknown, ThrowOnError> => (options?.client ?? client).get<HealthLiveResponses, unknown, ThrowOnError>({ url: '/api/v1/health/live', ...options });

/**
 * Worker
 *
 * Is a worker alive? 200 when one has heartbeated recently, 503 otherwise.
 *
 * For an outside uptime monitor to poll. The thing that alerts must not be
 * the thing that fails, so the worker cannot be the one to say it is down;
 * the API answers from the heartbeat the worker leaves in the database.
 */
export const healthWorker = <ThrowOnError extends boolean = false>(options?: Options<HealthWorkerData, ThrowOnError>): RequestResult<HealthWorkerResponses, unknown, ThrowOnError> => (options?.client ?? client).get<HealthWorkerResponses, unknown, ThrowOnError>({ url: '/api/v1/health/worker', ...options });

/**
 * Ready
 */
export const healthReady = <ThrowOnError extends boolean = false>(options?: Options<HealthReadyData, ThrowOnError>): RequestResult<HealthReadyResponses, unknown, ThrowOnError> => (options?.client ?? client).get<HealthReadyResponses, unknown, ThrowOnError>({ url: '/api/v1/health/ready', ...options });

/**
 * Login
 */
export const authLogin = <ThrowOnError extends boolean = false>(options: Options<AuthLoginData, ThrowOnError>): RequestResult<AuthLoginResponses, AuthLoginErrors, ThrowOnError> => (options.client ?? client).post<AuthLoginResponses, AuthLoginErrors, ThrowOnError>({
    url: '/api/v1/auth/login',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Refresh
 */
export const authRefresh = <ThrowOnError extends boolean = false>(options?: Options<AuthRefreshData, ThrowOnError>): RequestResult<AuthRefreshResponses, unknown, ThrowOnError> => (options?.client ?? client).post<AuthRefreshResponses, unknown, ThrowOnError>({ url: '/api/v1/auth/refresh', ...options });

/**
 * Logout
 */
export const authLogout = <ThrowOnError extends boolean = false>(options?: Options<AuthLogoutData, ThrowOnError>): RequestResult<AuthLogoutResponses, unknown, ThrowOnError> => (options?.client ?? client).post<AuthLogoutResponses, unknown, ThrowOnError>({ url: '/api/v1/auth/logout', ...options });

/**
 * Me
 */
export const authMe = <ThrowOnError extends boolean = false>(options?: Options<AuthMeData, ThrowOnError>): RequestResult<AuthMeResponses, unknown, ThrowOnError> => (options?.client ?? client).get<AuthMeResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/auth/me',
    ...options
});

/**
 * Updateme
 *
 * Your own name and title. Nothing else about you is yours to change here.
 */
export const authUpdateMe = <ThrowOnError extends boolean = false>(options: Options<AuthUpdateMeData, ThrowOnError>): RequestResult<AuthUpdateMeResponses, AuthUpdateMeErrors, ThrowOnError> => (options.client ?? client).patch<AuthUpdateMeResponses, AuthUpdateMeErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/auth/me',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Changepassword
 *
 * A new password, proven by the current one. Other devices are signed out.
 */
export const authChangePassword = <ThrowOnError extends boolean = false>(options: Options<AuthChangePasswordData, ThrowOnError>): RequestResult<AuthChangePasswordResponses, AuthChangePasswordErrors, ThrowOnError> => (options.client ?? client).post<AuthChangePasswordResponses, AuthChangePasswordErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/auth/password/change',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Forgotpassword
 *
 * Email a reset link. The answer is the same whether or not the address
 * is known: anything else is a way to list accounts.
 */
export const authForgotPassword = <ThrowOnError extends boolean = false>(options: Options<AuthForgotPasswordData, ThrowOnError>): RequestResult<AuthForgotPasswordResponses, AuthForgotPasswordErrors, ThrowOnError> => (options.client ?? client).post<AuthForgotPasswordResponses, AuthForgotPasswordErrors, ThrowOnError>({
    url: '/api/v1/auth/password/forgot',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Resetpreview
 *
 * Whether the link still works, so the page can say so before the form.
 */
export const authResetPreview = <ThrowOnError extends boolean = false>(options: Options<AuthResetPreviewData, ThrowOnError>): RequestResult<AuthResetPreviewResponses, AuthResetPreviewErrors, ThrowOnError> => (options.client ?? client).get<AuthResetPreviewResponses, AuthResetPreviewErrors, ThrowOnError>({ url: '/api/v1/auth/password/reset/{token}', ...options });

/**
 * Resetpassword
 *
 * Set the new password and sign in, in one step. Every other session
 * for the account is signed out.
 */
export const authResetPassword = <ThrowOnError extends boolean = false>(options: Options<AuthResetPasswordData, ThrowOnError>): RequestResult<AuthResetPasswordResponses, AuthResetPasswordErrors, ThrowOnError> => (options.client ?? client).post<AuthResetPasswordResponses, AuthResetPasswordErrors, ThrowOnError>({
    url: '/api/v1/auth/password/reset/{token}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List
 */
export const usersList = <ThrowOnError extends boolean = false>(options?: Options<UsersListData, ThrowOnError>): RequestResult<UsersListResponses, UsersListErrors, ThrowOnError> => (options?.client ?? client).get<UsersListResponses, UsersListErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/users',
    ...options
});

/**
 * Create
 */
export const usersCreate = <ThrowOnError extends boolean = false>(options: Options<UsersCreateData, ThrowOnError>): RequestResult<UsersCreateResponses, UsersCreateErrors, ThrowOnError> => (options.client ?? client).post<UsersCreateResponses, UsersCreateErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/users',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get
 */
export const usersGet = <ThrowOnError extends boolean = false>(options: Options<UsersGetData, ThrowOnError>): RequestResult<UsersGetResponses, UsersGetErrors, ThrowOnError> => (options.client ?? client).get<UsersGetResponses, UsersGetErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/users/{user_id}',
    ...options
});

/**
 * Update
 */
export const usersUpdate = <ThrowOnError extends boolean = false>(options: Options<UsersUpdateData, ThrowOnError>): RequestResult<UsersUpdateResponses, UsersUpdateErrors, ThrowOnError> => (options.client ?? client).patch<UsersUpdateResponses, UsersUpdateErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/users/{user_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List
 *
 * Active orgs by default; archived and removed ones are their own lists.
 */
export const orgsList = <ThrowOnError extends boolean = false>(options?: Options<OrgsListData, ThrowOnError>): RequestResult<OrgsListResponses, OrgsListErrors, ThrowOnError> => (options?.client ?? client).get<OrgsListResponses, OrgsListErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/orgs',
    ...options
});

/**
 * Create
 */
export const orgsCreate = <ThrowOnError extends boolean = false>(options: Options<OrgsCreateData, ThrowOnError>): RequestResult<OrgsCreateResponses, OrgsCreateErrors, ThrowOnError> => (options.client ?? client).post<OrgsCreateResponses, OrgsCreateErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/orgs',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Mine
 *
 * The caller's own organization (SMM and employees).
 */
export const orgsMine = <ThrowOnError extends boolean = false>(options?: Options<OrgsMineData, ThrowOnError>): RequestResult<OrgsMineResponses, unknown, ThrowOnError> => (options?.client ?? client).get<OrgsMineResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/orgs/me',
    ...options
});

/**
 * Get
 */
export const orgsGet = <ThrowOnError extends boolean = false>(options: Options<OrgsGetData, ThrowOnError>): RequestResult<OrgsGetResponses, OrgsGetErrors, ThrowOnError> => (options.client ?? client).get<OrgsGetResponses, OrgsGetErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/orgs/{org_id}',
    ...options
});

/**
 * Update
 */
export const orgsUpdate = <ThrowOnError extends boolean = false>(options: Options<OrgsUpdateData, ThrowOnError>): RequestResult<OrgsUpdateResponses, OrgsUpdateErrors, ThrowOnError> => (options.client ?? client).patch<OrgsUpdateResponses, OrgsUpdateErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/orgs/{org_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List
 */
export const brandTemplatesList = <ThrowOnError extends boolean = false>(options?: Options<BrandTemplatesListData, ThrowOnError>): RequestResult<BrandTemplatesListResponses, BrandTemplatesListErrors, ThrowOnError> => (options?.client ?? client).get<BrandTemplatesListResponses, BrandTemplatesListErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/brand-templates',
    ...options
});

/**
 * Create
 */
export const brandTemplatesCreate = <ThrowOnError extends boolean = false>(options: Options<BrandTemplatesCreateData, ThrowOnError>): RequestResult<BrandTemplatesCreateResponses, BrandTemplatesCreateErrors, ThrowOnError> => (options.client ?? client).post<BrandTemplatesCreateResponses, BrandTemplatesCreateErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/brand-templates',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Duplicate
 */
export const brandTemplatesDuplicate = <ThrowOnError extends boolean = false>(options: Options<BrandTemplatesDuplicateData, ThrowOnError>): RequestResult<BrandTemplatesDuplicateResponses, BrandTemplatesDuplicateErrors, ThrowOnError> => (options.client ?? client).post<BrandTemplatesDuplicateResponses, BrandTemplatesDuplicateErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/brand-templates/{config_id}/duplicate',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Createfororg
 *
 * Start a client's brand setup from nothing, when no template fits.
 */
export const brandConfigsCreateForOrg = <ThrowOnError extends boolean = false>(options: Options<BrandConfigsCreateForOrgData, ThrowOnError>): RequestResult<BrandConfigsCreateForOrgResponses, BrandConfigsCreateForOrgErrors, ThrowOnError> => (options.client ?? client).post<BrandConfigsCreateForOrgResponses, BrandConfigsCreateForOrgErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/brand-configs',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete
 */
export const brandConfigsDelete = <ThrowOnError extends boolean = false>(options: Options<BrandConfigsDeleteData, ThrowOnError>): RequestResult<BrandConfigsDeleteResponses, BrandConfigsDeleteErrors, ThrowOnError> => (options.client ?? client).delete<BrandConfigsDeleteResponses, BrandConfigsDeleteErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/brand-configs/{config_id}',
    ...options
});

/**
 * Get
 */
export const brandConfigsGet = <ThrowOnError extends boolean = false>(options: Options<BrandConfigsGetData, ThrowOnError>): RequestResult<BrandConfigsGetResponses, BrandConfigsGetErrors, ThrowOnError> => (options.client ?? client).get<BrandConfigsGetResponses, BrandConfigsGetErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/brand-configs/{config_id}',
    ...options
});

/**
 * Update
 */
export const brandConfigsUpdate = <ThrowOnError extends boolean = false>(options: Options<BrandConfigsUpdateData, ThrowOnError>): RequestResult<BrandConfigsUpdateResponses, BrandConfigsUpdateErrors, ThrowOnError> => (options.client ?? client).patch<BrandConfigsUpdateResponses, BrandConfigsUpdateErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/brand-configs/{config_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Addvoicepillar
 */
export const brandConfigsAddVoicePillar = <ThrowOnError extends boolean = false>(options: Options<BrandConfigsAddVoicePillarData, ThrowOnError>): RequestResult<BrandConfigsAddVoicePillarResponses, BrandConfigsAddVoicePillarErrors, ThrowOnError> => (options.client ?? client).post<BrandConfigsAddVoicePillarResponses, BrandConfigsAddVoicePillarErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/brand-configs/{config_id}/voice-pillars',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Deletevoicepillar
 */
export const brandConfigsDeleteVoicePillar = <ThrowOnError extends boolean = false>(options: Options<BrandConfigsDeleteVoicePillarData, ThrowOnError>): RequestResult<BrandConfigsDeleteVoicePillarResponses, BrandConfigsDeleteVoicePillarErrors, ThrowOnError> => (options.client ?? client).delete<BrandConfigsDeleteVoicePillarResponses, BrandConfigsDeleteVoicePillarErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/brand-configs/{config_id}/voice-pillars/{pillar_id}',
    ...options
});

/**
 * Updatevoicepillar
 */
export const brandConfigsUpdateVoicePillar = <ThrowOnError extends boolean = false>(options: Options<BrandConfigsUpdateVoicePillarData, ThrowOnError>): RequestResult<BrandConfigsUpdateVoicePillarResponses, BrandConfigsUpdateVoicePillarErrors, ThrowOnError> => (options.client ?? client).patch<BrandConfigsUpdateVoicePillarResponses, BrandConfigsUpdateVoicePillarErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/brand-configs/{config_id}/voice-pillars/{pillar_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Reordervoicepillars
 */
export const brandConfigsReorderVoicePillars = <ThrowOnError extends boolean = false>(options: Options<BrandConfigsReorderVoicePillarsData, ThrowOnError>): RequestResult<BrandConfigsReorderVoicePillarsResponses, BrandConfigsReorderVoicePillarsErrors, ThrowOnError> => (options.client ?? client).post<BrandConfigsReorderVoicePillarsResponses, BrandConfigsReorderVoicePillarsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/brand-configs/{config_id}/voice-pillars/reorder',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Addcontentpillar
 */
export const brandConfigsAddContentPillar = <ThrowOnError extends boolean = false>(options: Options<BrandConfigsAddContentPillarData, ThrowOnError>): RequestResult<BrandConfigsAddContentPillarResponses, BrandConfigsAddContentPillarErrors, ThrowOnError> => (options.client ?? client).post<BrandConfigsAddContentPillarResponses, BrandConfigsAddContentPillarErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/brand-configs/{config_id}/content-pillars',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Deletecontentpillar
 */
export const brandConfigsDeleteContentPillar = <ThrowOnError extends boolean = false>(options: Options<BrandConfigsDeleteContentPillarData, ThrowOnError>): RequestResult<BrandConfigsDeleteContentPillarResponses, BrandConfigsDeleteContentPillarErrors, ThrowOnError> => (options.client ?? client).delete<BrandConfigsDeleteContentPillarResponses, BrandConfigsDeleteContentPillarErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/brand-configs/{config_id}/content-pillars/{pillar_id}',
    ...options
});

/**
 * Updatecontentpillar
 */
export const brandConfigsUpdateContentPillar = <ThrowOnError extends boolean = false>(options: Options<BrandConfigsUpdateContentPillarData, ThrowOnError>): RequestResult<BrandConfigsUpdateContentPillarResponses, BrandConfigsUpdateContentPillarErrors, ThrowOnError> => (options.client ?? client).patch<BrandConfigsUpdateContentPillarResponses, BrandConfigsUpdateContentPillarErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/brand-configs/{config_id}/content-pillars/{pillar_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Reordercontentpillars
 */
export const brandConfigsReorderContentPillars = <ThrowOnError extends boolean = false>(options: Options<BrandConfigsReorderContentPillarsData, ThrowOnError>): RequestResult<BrandConfigsReorderContentPillarsResponses, BrandConfigsReorderContentPillarsErrors, ThrowOnError> => (options.client ?? client).post<BrandConfigsReorderContentPillarsResponses, BrandConfigsReorderContentPillarsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/brand-configs/{config_id}/content-pillars/reorder',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Savetipsheet
 */
export const brandConfigsSaveTipSheet = <ThrowOnError extends boolean = false>(options: Options<BrandConfigsSaveTipSheetData, ThrowOnError>): RequestResult<BrandConfigsSaveTipSheetResponses, BrandConfigsSaveTipSheetErrors, ThrowOnError> => (options.client ?? client).put<BrandConfigsSaveTipSheetResponses, BrandConfigsSaveTipSheetErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/brand-configs/{config_id}/tip-sheets/{platform}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Review
 *
 * The org's setup with its review state. Empty until The Motherhood builds one.
 */
export const brandReview = <ThrowOnError extends boolean = false>(options?: Options<BrandReviewData, ThrowOnError>): RequestResult<BrandReviewResponses, BrandReviewErrors, ThrowOnError> => (options?.client ?? client).get<BrandReviewResponses, BrandReviewErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/brand/review',
    ...options
});

/**
 * Addcomment
 */
export const brandAddComment = <ThrowOnError extends boolean = false>(options: Options<BrandAddCommentData, ThrowOnError>): RequestResult<BrandAddCommentResponses, BrandAddCommentErrors, ThrowOnError> => (options.client ?? client).post<BrandAddCommentResponses, BrandAddCommentErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/brand/review/comments',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Approve
 */
export const brandApprove = <ThrowOnError extends boolean = false>(options?: Options<BrandApproveData, ThrowOnError>): RequestResult<BrandApproveResponses, BrandApproveErrors, ThrowOnError> => (options?.client ?? client).post<BrandApproveResponses, BrandApproveErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/brand/review/approve',
    ...options
});

/**
 * Resolvecomment
 */
export const brandResolveComment = <ThrowOnError extends boolean = false>(options: Options<BrandResolveCommentData, ThrowOnError>): RequestResult<BrandResolveCommentResponses, BrandResolveCommentErrors, ThrowOnError> => (options.client ?? client).post<BrandResolveCommentResponses, BrandResolveCommentErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/brand/review/comments/{comment_id}/resolve',
    ...options
});

/**
 * List
 */
export const invitationsList = <ThrowOnError extends boolean = false>(options?: Options<InvitationsListData, ThrowOnError>): RequestResult<InvitationsListResponses, InvitationsListErrors, ThrowOnError> => (options?.client ?? client).get<InvitationsListResponses, InvitationsListErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/invitations',
    ...options
});

/**
 * Create
 */
export const invitationsCreate = <ThrowOnError extends boolean = false>(options: Options<InvitationsCreateData, ThrowOnError>): RequestResult<InvitationsCreateResponses, InvitationsCreateErrors, ThrowOnError> => (options.client ?? client).post<InvitationsCreateResponses, InvitationsCreateErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/invitations',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Revoke
 */
export const invitationsRevoke = <ThrowOnError extends boolean = false>(options: Options<InvitationsRevokeData, ThrowOnError>): RequestResult<InvitationsRevokeResponses, InvitationsRevokeErrors, ThrowOnError> => (options.client ?? client).post<InvitationsRevokeResponses, InvitationsRevokeErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/invitations/{invitation_id}/revoke',
    ...options
});

/**
 * Preview
 */
export const invitationsPreview = <ThrowOnError extends boolean = false>(options: Options<InvitationsPreviewData, ThrowOnError>): RequestResult<InvitationsPreviewResponses, InvitationsPreviewErrors, ThrowOnError> => (options.client ?? client).get<InvitationsPreviewResponses, InvitationsPreviewErrors, ThrowOnError>({ url: '/api/v1/invitations/token/{token}', ...options });

/**
 * Accept
 *
 * Set a password and sign in, in one step.
 */
export const invitationsAccept = <ThrowOnError extends boolean = false>(options: Options<InvitationsAcceptData, ThrowOnError>): RequestResult<InvitationsAcceptResponses, InvitationsAcceptErrors, ThrowOnError> => (options.client ?? client).post<InvitationsAcceptResponses, InvitationsAcceptErrors, ThrowOnError>({
    url: '/api/v1/invitations/token/{token}/accept',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List
 *
 * Everyone who writes a prompt needs the dropdown, so any signed-in user
 * may read this. Only The Motherhood may change it.
 */
export const frameworksList = <ThrowOnError extends boolean = false>(options?: Options<FrameworksListData, ThrowOnError>): RequestResult<FrameworksListResponses, FrameworksListErrors, ThrowOnError> => (options?.client ?? client).get<FrameworksListResponses, FrameworksListErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/prompt-frameworks',
    ...options
});

/**
 * Create
 */
export const frameworksCreate = <ThrowOnError extends boolean = false>(options: Options<FrameworksCreateData, ThrowOnError>): RequestResult<FrameworksCreateResponses, FrameworksCreateErrors, ThrowOnError> => (options.client ?? client).post<FrameworksCreateResponses, FrameworksCreateErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/prompt-frameworks',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete
 */
export const frameworksDelete = <ThrowOnError extends boolean = false>(options: Options<FrameworksDeleteData, ThrowOnError>): RequestResult<FrameworksDeleteResponses, FrameworksDeleteErrors, ThrowOnError> => (options.client ?? client).delete<FrameworksDeleteResponses, FrameworksDeleteErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/prompt-frameworks/{framework_id}',
    ...options
});

/**
 * Update
 */
export const frameworksUpdate = <ThrowOnError extends boolean = false>(options: Options<FrameworksUpdateData, ThrowOnError>): RequestResult<FrameworksUpdateResponses, FrameworksUpdateErrors, ThrowOnError> => (options.client ?? client).patch<FrameworksUpdateResponses, FrameworksUpdateErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/prompt-frameworks/{framework_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Listforconfig
 */
export const promptsListForConfig = <ThrowOnError extends boolean = false>(options: Options<PromptsListForConfigData, ThrowOnError>): RequestResult<PromptsListForConfigResponses, PromptsListForConfigErrors, ThrowOnError> => (options.client ?? client).get<PromptsListForConfigResponses, PromptsListForConfigErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/prompts/config/{config_id}',
    ...options
});

/**
 * Createforconfig
 */
export const promptsCreateForConfig = <ThrowOnError extends boolean = false>(options: Options<PromptsCreateForConfigData, ThrowOnError>): RequestResult<PromptsCreateForConfigResponses, PromptsCreateForConfigErrors, ThrowOnError> => (options.client ?? client).post<PromptsCreateForConfigResponses, PromptsCreateForConfigErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/prompts/config/{config_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Deleteforconfig
 */
export const promptsDeleteForConfig = <ThrowOnError extends boolean = false>(options: Options<PromptsDeleteForConfigData, ThrowOnError>): RequestResult<PromptsDeleteForConfigResponses, PromptsDeleteForConfigErrors, ThrowOnError> => (options.client ?? client).delete<PromptsDeleteForConfigResponses, PromptsDeleteForConfigErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/prompts/config/{config_id}/{prompt_id}',
    ...options
});

/**
 * Updateforconfig
 */
export const promptsUpdateForConfig = <ThrowOnError extends boolean = false>(options: Options<PromptsUpdateForConfigData, ThrowOnError>): RequestResult<PromptsUpdateForConfigResponses, PromptsUpdateForConfigErrors, ThrowOnError> => (options.client ?? client).patch<PromptsUpdateForConfigResponses, PromptsUpdateForConfigErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/prompts/config/{config_id}/{prompt_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Mine
 *
 * The whole library: The Motherhood's prompts and the client's own.
 *
 * An org whose setup is not written yet has an empty library, which is the
 * truth and is what the screen already knows how to show. Reading a list
 * never fails just because the list is empty.
 */
export const promptsMine = <ThrowOnError extends boolean = false>(options?: Options<PromptsMineData, ThrowOnError>): RequestResult<PromptsMineResponses, PromptsMineErrors, ThrowOnError> => (options?.client ?? client).get<PromptsMineResponses, PromptsMineErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/prompts',
    ...options
});

/**
 * Addmine
 */
export const promptsAddMine = <ThrowOnError extends boolean = false>(options: Options<PromptsAddMineData, ThrowOnError>): RequestResult<PromptsAddMineResponses, PromptsAddMineErrors, ThrowOnError> => (options.client ?? client).post<PromptsAddMineResponses, PromptsAddMineErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/prompts',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Duplicatemine
 *
 * Make an editable copy of a prompt, which is how a client reworks one of
 * The Motherhood's without overwriting it.
 */
export const promptsDuplicateMine = <ThrowOnError extends boolean = false>(options: Options<PromptsDuplicateMineData, ThrowOnError>): RequestResult<PromptsDuplicateMineResponses, PromptsDuplicateMineErrors, ThrowOnError> => (options.client ?? client).post<PromptsDuplicateMineResponses, PromptsDuplicateMineErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/prompts/{prompt_id}/duplicate',
    ...options
});

/**
 * Deletemine
 */
export const promptsDeleteMine = <ThrowOnError extends boolean = false>(options: Options<PromptsDeleteMineData, ThrowOnError>): RequestResult<PromptsDeleteMineResponses, PromptsDeleteMineErrors, ThrowOnError> => (options.client ?? client).delete<PromptsDeleteMineResponses, PromptsDeleteMineErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/prompts/{prompt_id}',
    ...options
});

/**
 * Updatemine
 */
export const promptsUpdateMine = <ThrowOnError extends boolean = false>(options: Options<PromptsUpdateMineData, ThrowOnError>): RequestResult<PromptsUpdateMineResponses, PromptsUpdateMineErrors, ThrowOnError> => (options.client ?? client).patch<PromptsUpdateMineResponses, PromptsUpdateMineErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/prompts/{prompt_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List
 */
export const plansList = <ThrowOnError extends boolean = false>(options?: Options<PlansListData, ThrowOnError>): RequestResult<PlansListResponses, PlansListErrors, ThrowOnError> => (options?.client ?? client).get<PlansListResponses, PlansListErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/plans',
    ...options
});

/**
 * Create
 */
export const plansCreate = <ThrowOnError extends boolean = false>(options: Options<PlansCreateData, ThrowOnError>): RequestResult<PlansCreateResponses, PlansCreateErrors, ThrowOnError> => (options.client ?? client).post<PlansCreateResponses, PlansCreateErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/plans',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Bymonth
 *
 * The plan for a given month, or nothing if it has not been started.
 */
export const plansByMonth = <ThrowOnError extends boolean = false>(options: Options<PlansByMonthData, ThrowOnError>): RequestResult<PlansByMonthResponses, PlansByMonthErrors, ThrowOnError> => (options.client ?? client).get<PlansByMonthResponses, PlansByMonthErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/plans/by-month',
    ...options
});

/**
 * Delete
 */
export const plansDelete = <ThrowOnError extends boolean = false>(options: Options<PlansDeleteData, ThrowOnError>): RequestResult<PlansDeleteResponses, PlansDeleteErrors, ThrowOnError> => (options.client ?? client).delete<PlansDeleteResponses, PlansDeleteErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/plans/{plan_id}',
    ...options
});

/**
 * Get
 */
export const plansGet = <ThrowOnError extends boolean = false>(options: Options<PlansGetData, ThrowOnError>): RequestResult<PlansGetResponses, PlansGetErrors, ThrowOnError> => (options.client ?? client).get<PlansGetResponses, PlansGetErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/plans/{plan_id}',
    ...options
});

/**
 * Update
 */
export const plansUpdate = <ThrowOnError extends boolean = false>(options: Options<PlansUpdateData, ThrowOnError>): RequestResult<PlansUpdateResponses, PlansUpdateErrors, ThrowOnError> => (options.client ?? client).patch<PlansUpdateResponses, PlansUpdateErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/plans/{plan_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Addevent
 */
export const plansAddEvent = <ThrowOnError extends boolean = false>(options: Options<PlansAddEventData, ThrowOnError>): RequestResult<PlansAddEventResponses, PlansAddEventErrors, ThrowOnError> => (options.client ?? client).post<PlansAddEventResponses, PlansAddEventErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/plans/{plan_id}/events',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Deleteevent
 */
export const plansDeleteEvent = <ThrowOnError extends boolean = false>(options: Options<PlansDeleteEventData, ThrowOnError>): RequestResult<PlansDeleteEventResponses, PlansDeleteEventErrors, ThrowOnError> => (options.client ?? client).delete<PlansDeleteEventResponses, PlansDeleteEventErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/plans/{plan_id}/events/{event_id}',
    ...options
});

/**
 * Updateevent
 */
export const plansUpdateEvent = <ThrowOnError extends boolean = false>(options: Options<PlansUpdateEventData, ThrowOnError>): RequestResult<PlansUpdateEventResponses, PlansUpdateEventErrors, ThrowOnError> => (options.client ?? client).patch<PlansUpdateEventResponses, PlansUpdateEventErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/plans/{plan_id}/events/{event_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Setprompts
 */
export const plansSetPrompts = <ThrowOnError extends boolean = false>(options: Options<PlansSetPromptsData, ThrowOnError>): RequestResult<PlansSetPromptsResponses, PlansSetPromptsErrors, ThrowOnError> => (options.client ?? client).put<PlansSetPromptsResponses, PlansSetPromptsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/plans/{plan_id}/prompts',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Generatemonth
 *
 * Ideas for the page and prompts for every ready teammate, in one press.
 *
 * Afterwards the page's ideas can be regenerated on their own; each
 * teammate rewrites their own prompts from their side, within a monthly cap.
 */
export const plansGenerateMonth = <ThrowOnError extends boolean = false>(options: Options<PlansGenerateMonthData, ThrowOnError>): RequestResult<PlansGenerateMonthResponses, PlansGenerateMonthErrors, ThrowOnError> => (options.client ?? client).post<PlansGenerateMonthResponses, PlansGenerateMonthErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/plans/{plan_id}/generate',
    ...options
});

/**
 * Generatepage
 *
 * Ideas for the organisation's own Page, for the SMM to write posts from.
 *
 * Runs inline: this is one model call. The per-employee run below is the one
 * that will move to the worker.
 */
export const plansGeneratePage = <ThrowOnError extends boolean = false>(options: Options<PlansGeneratePageData, ThrowOnError>): RequestResult<PlansGeneratePageResponses, PlansGeneratePageErrors, ThrowOnError> => (options.client ?? client).post<PlansGeneratePageResponses, PlansGeneratePageErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/plans/{plan_id}/generate/page',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Generateemployees
 *
 * A private set for each employee, from the same month.
 *
 * Their voice profile is not part of this yet; when that feature lands it
 * becomes another block of context and nothing here changes.
 */
export const plansGenerateEmployees = <ThrowOnError extends boolean = false>(options: Options<PlansGenerateEmployeesData, ThrowOnError>): RequestResult<PlansGenerateEmployeesResponses, PlansGenerateEmployeesErrors, ThrowOnError> => (options.client ?? client).post<PlansGenerateEmployeesResponses, PlansGenerateEmployeesErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/plans/{plan_id}/generate/employees',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Addpost
 *
 * Schedule a post the SMM has written. The body is always theirs.
 */
export const plansAddPost = <ThrowOnError extends boolean = false>(options: Options<PlansAddPostData, ThrowOnError>): RequestResult<PlansAddPostResponses, PlansAddPostErrors, ThrowOnError> => (options.client ?? client).post<PlansAddPostResponses, PlansAddPostErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/plans/{plan_id}/posts',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Deletepost
 */
export const plansDeletePost = <ThrowOnError extends boolean = false>(options: Options<PlansDeletePostData, ThrowOnError>): RequestResult<PlansDeletePostResponses, PlansDeletePostErrors, ThrowOnError> => (options.client ?? client).delete<PlansDeletePostResponses, PlansDeletePostErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/plans/{plan_id}/posts/{post_id}',
    ...options
});

/**
 * Updatepost
 */
export const plansUpdatePost = <ThrowOnError extends boolean = false>(options: Options<PlansUpdatePostData, ThrowOnError>): RequestResult<PlansUpdatePostResponses, PlansUpdatePostErrors, ThrowOnError> => (options.client ?? client).patch<PlansUpdatePostResponses, PlansUpdatePostErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/plans/{plan_id}/posts/{post_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Options
 *
 * The words to pick from. Read by anyone signed in, since it is a
 * vocabulary rather than anybody's answers.
 */
export const voiceOptions = <ThrowOnError extends boolean = false>(options?: Options<VoiceOptionsData, ThrowOnError>): RequestResult<VoiceOptionsResponses, unknown, ThrowOnError> => (options?.client ?? client).get<VoiceOptionsResponses, unknown, ThrowOnError>({ url: '/api/v1/voice-profiles/options', ...options });

/**
 * Mine
 *
 * Null until they start. The row appears on the first save.
 */
export const voiceMine = <ThrowOnError extends boolean = false>(options?: Options<VoiceMineData, ThrowOnError>): RequestResult<VoiceMineResponses, unknown, ThrowOnError> => (options?.client ?? client).get<VoiceMineResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/voice-profiles/me',
    ...options
});

/**
 * Stageone
 */
export const voiceStageOne = <ThrowOnError extends boolean = false>(options: Options<VoiceStageOneData, ThrowOnError>): RequestResult<VoiceStageOneResponses, VoiceStageOneErrors, ThrowOnError> => (options.client ?? client).put<VoiceStageOneResponses, VoiceStageOneErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/voice-profiles/me/stage-one',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Stagethree
 */
export const voiceStageThree = <ThrowOnError extends boolean = false>(options: Options<VoiceStageThreeData, ThrowOnError>): RequestResult<VoiceStageThreeResponses, VoiceStageThreeErrors, ThrowOnError> => (options.client ?? client).put<VoiceStageThreeResponses, VoiceStageThreeErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/voice-profiles/me/stage-three',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Addsample
 */
export const voiceAddSample = <ThrowOnError extends boolean = false>(options: Options<VoiceAddSampleData, ThrowOnError>): RequestResult<VoiceAddSampleResponses, VoiceAddSampleErrors, ThrowOnError> => (options.client ?? client).post<VoiceAddSampleResponses, VoiceAddSampleErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/voice-profiles/me/samples',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Deletesample
 */
export const voiceDeleteSample = <ThrowOnError extends boolean = false>(options: Options<VoiceDeleteSampleData, ThrowOnError>): RequestResult<VoiceDeleteSampleResponses, VoiceDeleteSampleErrors, ThrowOnError> => (options.client ?? client).delete<VoiceDeleteSampleResponses, VoiceDeleteSampleErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/voice-profiles/me/samples/{sample_id}',
    ...options
});

/**
 * Updatesample
 */
export const voiceUpdateSample = <ThrowOnError extends boolean = false>(options: Options<VoiceUpdateSampleData, ThrowOnError>): RequestResult<VoiceUpdateSampleResponses, VoiceUpdateSampleErrors, ThrowOnError> => (options.client ?? client).patch<VoiceUpdateSampleResponses, VoiceUpdateSampleErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/voice-profiles/me/samples/{sample_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Teamreadiness
 *
 * How many of the team can be generated for. Two numbers, no names.
 */
export const voiceTeamReadiness = <ThrowOnError extends boolean = false>(options?: Options<VoiceTeamReadinessData, ThrowOnError>): RequestResult<VoiceTeamReadinessResponses, VoiceTeamReadinessErrors, ThrowOnError> => (options?.client ?? client).get<VoiceTeamReadinessResponses, VoiceTeamReadinessErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/voice-profiles/team-readiness',
    ...options
});

/**
 * Mymonth
 *
 * This month's prompts, plus enough context to know why there are none.
 *
 * Always returns a shape. An employee with no prompts needs to know which of
 * three things is true, and a bare empty list tells them none of it.
 */
export const generationMyMonth = <ThrowOnError extends boolean = false>(options?: Options<GenerationMyMonthData, ThrowOnError>): RequestResult<GenerationMyMonthResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GenerationMyMonthResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/me/month',
    ...options
});

/**
 * Generatemine
 *
 * Write this month's prompts for the person asking.
 *
 * For whoever joined after the SMM sent the month out, or changed their voice
 * profile since. One model call, for one person; the rest of the team's
 * prompts are untouched. Returns the month as it now reads.
 */
export const generationGenerateMine = <ThrowOnError extends boolean = false>(options?: Options<GenerationGenerateMineData, ThrowOnError>): RequestResult<GenerationGenerateMineResponses, unknown, ThrowOnError> => (options?.client ?? client).post<GenerationGenerateMineResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/me/month/generate',
    ...options
});

/**
 * Setup
 */
export const dashboardSetup = <ThrowOnError extends boolean = false>(options?: Options<DashboardSetupData, ThrowOnError>): RequestResult<DashboardSetupResponses, DashboardSetupErrors, ThrowOnError> => (options?.client ?? client).get<DashboardSetupResponses, DashboardSetupErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/team/setup',
    ...options
});

/**
 * Roster
 *
 * Everyone on the team and everyone invited. Counts and states only.
 */
export const dashboardRoster = <ThrowOnError extends boolean = false>(options?: Options<DashboardRosterData, ThrowOnError>): RequestResult<DashboardRosterResponses, DashboardRosterErrors, ThrowOnError> => (options?.client ?? client).get<DashboardRosterResponses, DashboardRosterErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/team/roster',
    ...options
});

/**
 * Pillarcoverage
 */
export const dashboardPillarCoverage = <ThrowOnError extends boolean = false>(options?: Options<DashboardPillarCoverageData, ThrowOnError>): RequestResult<DashboardPillarCoverageResponses, DashboardPillarCoverageErrors, ThrowOnError> => (options?.client ?? client).get<DashboardPillarCoverageResponses, DashboardPillarCoverageErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/team/pillar-coverage',
    ...options
});

/**
 * Pagesnapshot
 */
export const dashboardPageSnapshot = <ThrowOnError extends boolean = false>(options?: Options<DashboardPageSnapshotData, ThrowOnError>): RequestResult<DashboardPageSnapshotResponses, DashboardPageSnapshotErrors, ThrowOnError> => (options?.client ?? client).get<DashboardPageSnapshotResponses, DashboardPageSnapshotErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/team/page-snapshot',
    ...options
});

/**
 * List
 *
 * Newest first. `archived` switches to the archived view.
 */
export const momentsList = <ThrowOnError extends boolean = false>(options?: Options<MomentsListData, ThrowOnError>): RequestResult<MomentsListResponses, MomentsListErrors, ThrowOnError> => (options?.client ?? client).get<MomentsListResponses, MomentsListErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/me/moments',
    ...options
});

/**
 * Add
 */
export const momentsAdd = <ThrowOnError extends boolean = false>(options: Options<MomentsAddData, ThrowOnError>): RequestResult<MomentsAddResponses, MomentsAddErrors, ThrowOnError> => (options.client ?? client).post<MomentsAddResponses, MomentsAddErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/me/moments',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get
 *
 * One moment, archived or not: an idea's source link always opens it.
 */
export const momentsGet = <ThrowOnError extends boolean = false>(options: Options<MomentsGetData, ThrowOnError>): RequestResult<MomentsGetResponses, MomentsGetErrors, ThrowOnError> => (options.client ?? client).get<MomentsGetResponses, MomentsGetErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/me/moments/{moment_id}',
    ...options
});

/**
 * Update
 */
export const momentsUpdate = <ThrowOnError extends boolean = false>(options: Options<MomentsUpdateData, ThrowOnError>): RequestResult<MomentsUpdateResponses, MomentsUpdateErrors, ThrowOnError> => (options.client ?? client).patch<MomentsUpdateResponses, MomentsUpdateErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/me/moments/{moment_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Archive
 *
 * There is no delete. An archived moment keeps its words and its ideas.
 */
export const momentsArchive = <ThrowOnError extends boolean = false>(options: Options<MomentsArchiveData, ThrowOnError>): RequestResult<MomentsArchiveResponses, MomentsArchiveErrors, ThrowOnError> => (options.client ?? client).post<MomentsArchiveResponses, MomentsArchiveErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/me/moments/{moment_id}/archive',
    ...options
});

/**
 * Restore
 */
export const momentsRestore = <ThrowOnError extends boolean = false>(options: Options<MomentsRestoreData, ThrowOnError>): RequestResult<MomentsRestoreResponses, MomentsRestoreErrors, ThrowOnError> => (options.client ?? client).post<MomentsRestoreResponses, MomentsRestoreErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/me/moments/{moment_id}/restore',
    ...options
});

/**
 * Startmediaupload
 *
 * A signed grant to send one photo or video straight to storage.
 */
export const momentsStartMediaUpload = <ThrowOnError extends boolean = false>(options: Options<MomentsStartMediaUploadData, ThrowOnError>): RequestResult<MomentsStartMediaUploadResponses, MomentsStartMediaUploadErrors, ThrowOnError> => (options.client ?? client).post<MomentsStartMediaUploadResponses, MomentsStartMediaUploadErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/me/moments/{moment_id}/media/uploads',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Confirmmedia
 */
export const momentsConfirmMedia = <ThrowOnError extends boolean = false>(options: Options<MomentsConfirmMediaData, ThrowOnError>): RequestResult<MomentsConfirmMediaResponses, MomentsConfirmMediaErrors, ThrowOnError> => (options.client ?? client).post<MomentsConfirmMediaResponses, MomentsConfirmMediaErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/me/moments/{moment_id}/media/{media_id}/confirm',
    ...options
});

/**
 * Removemedia
 */
export const momentsRemoveMedia = <ThrowOnError extends boolean = false>(options: Options<MomentsRemoveMediaData, ThrowOnError>): RequestResult<MomentsRemoveMediaResponses, MomentsRemoveMediaErrors, ThrowOnError> => (options.client ?? client).delete<MomentsRemoveMediaResponses, MomentsRemoveMediaErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/me/moments/{moment_id}/media/{media_id}',
    ...options
});

/**
 * Getideas
 *
 * A few suggestions from this moment, added to the Ideas tab. Pressing
 * it again adds more; nothing already made is replaced.
 */
export const momentsGetIdeas = <ThrowOnError extends boolean = false>(options: Options<MomentsGetIdeasData, ThrowOnError>): RequestResult<MomentsGetIdeasResponses, MomentsGetIdeasErrors, ThrowOnError> => (options.client ?? client).post<MomentsGetIdeasResponses, MomentsGetIdeasErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/me/moments/{moment_id}/ideas',
    ...options
});

/**
 * List
 *
 * Published reports, most recent month first.
 */
export const reportsList = <ThrowOnError extends boolean = false>(options?: Options<ReportsListData, ThrowOnError>): RequestResult<ReportsListResponses, ReportsListErrors, ThrowOnError> => (options?.client ?? client).get<ReportsListResponses, ReportsListErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/client-reports',
    ...options
});

/**
 * Startupload
 */
export const reportsStartUpload = <ThrowOnError extends boolean = false>(options: Options<ReportsStartUploadData, ThrowOnError>): RequestResult<ReportsStartUploadResponses, ReportsStartUploadErrors, ThrowOnError> => (options.client ?? client).post<ReportsStartUploadResponses, ReportsStartUploadErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/client-reports/uploads',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Confirmupload
 */
export const reportsConfirmUpload = <ThrowOnError extends boolean = false>(options: Options<ReportsConfirmUploadData, ThrowOnError>): RequestResult<ReportsConfirmUploadResponses, ReportsConfirmUploadErrors, ThrowOnError> => (options.client ?? client).post<ReportsConfirmUploadResponses, ReportsConfirmUploadErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/client-reports/{report_id}/confirm',
    ...options
});

/**
 * Delete
 */
export const reportsDelete = <ThrowOnError extends boolean = false>(options: Options<ReportsDeleteData, ThrowOnError>): RequestResult<ReportsDeleteResponses, ReportsDeleteErrors, ThrowOnError> => (options.client ?? client).delete<ReportsDeleteResponses, ReportsDeleteErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/client-reports/{report_id}',
    ...options
});

/**
 * Archive
 *
 * Nobody in the org can sign in; the data stays; it can be restored.
 */
export const orgsArchive = <ThrowOnError extends boolean = false>(options: Options<OrgsArchiveData, ThrowOnError>): RequestResult<OrgsArchiveResponses, OrgsArchiveErrors, ThrowOnError> => (options.client ?? client).post<OrgsArchiveResponses, OrgsArchiveErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/orgs/{org_id}/archive',
    ...options
});

/**
 * Remove
 *
 * Start the 90-day clock and send everyone their download.
 */
export const orgsRemove = <ThrowOnError extends boolean = false>(options: Options<OrgsRemoveData, ThrowOnError>): RequestResult<OrgsRemoveResponses, OrgsRemoveErrors, ThrowOnError> => (options.client ?? client).post<OrgsRemoveResponses, OrgsRemoveErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/orgs/{org_id}/remove',
    ...options
});

/**
 * Restore
 *
 * Back to active, for everyone who had access. Cancels the clock and
 * withdraws the downloads.
 */
export const orgsRestore = <ThrowOnError extends boolean = false>(options: Options<OrgsRestoreData, ThrowOnError>): RequestResult<OrgsRestoreResponses, OrgsRestoreErrors, ThrowOnError> => (options.client ?? client).post<OrgsRestoreResponses, OrgsRestoreErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/orgs/{org_id}/restore',
    ...options
});

/**
 * Exports
 *
 * Each download a removal made: who it is for and whether it arrived.
 */
export const orgsExports = <ThrowOnError extends boolean = false>(options: Options<OrgsExportsData, ThrowOnError>): RequestResult<OrgsExportsResponses, OrgsExportsErrors, ThrowOnError> => (options.client ?? client).get<OrgsExportsResponses, OrgsExportsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/orgs/{org_id}/exports',
    ...options
});

/**
 * Retry Export
 */
export const orgsRetryExport = <ThrowOnError extends boolean = false>(options: Options<OrgsRetryExportData, ThrowOnError>): RequestResult<OrgsRetryExportResponses, OrgsRetryExportErrors, ThrowOnError> => (options.client ?? client).post<OrgsRetryExportResponses, OrgsRetryExportErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/orgs/{org_id}/exports/{export_id}/retry',
    ...options
});

/**
 * Export Link
 *
 * A fresh link to pass along another way, for a download whose email
 * did not arrive. The emailed link stops working.
 */
export const orgsExportLink = <ThrowOnError extends boolean = false>(options: Options<OrgsExportLinkData, ThrowOnError>): RequestResult<OrgsExportLinkResponses, OrgsExportLinkErrors, ThrowOnError> => (options.client ?? client).post<OrgsExportLinkResponses, OrgsExportLinkErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/orgs/{org_id}/exports/{export_id}/link',
    ...options
});

/**
 * Summary
 *
 * The count for the window and the one before it.
 */
export const mentionsSummary = <ThrowOnError extends boolean = false>(options?: Options<MentionsSummaryData, ThrowOnError>): RequestResult<MentionsSummaryResponses, MentionsSummaryErrors, ThrowOnError> => (options?.client ?? client).get<MentionsSummaryResponses, MentionsSummaryErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/org/mentions/summary',
    ...options
});

/**
 * List
 *
 * Posts that tagged the Page, newest first. A link out, and for the
 * first 48 hours a few words of the post.
 */
export const mentionsList = <ThrowOnError extends boolean = false>(options?: Options<MentionsListData, ThrowOnError>): RequestResult<MentionsListResponses, MentionsListErrors, ThrowOnError> => (options?.client ?? client).get<MentionsListResponses, MentionsListErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/org/mentions',
    ...options
});

/**
 * Month
 *
 * The month's count and the change from the month before, for a report.
 */
export const mentionsMonth = <ThrowOnError extends boolean = false>(options: Options<MentionsMonthData, ThrowOnError>): RequestResult<MentionsMonthResponses, MentionsMonthErrors, ThrowOnError> => (options.client ?? client).get<MentionsMonthResponses, MentionsMonthErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/orgs/{org_id}/mentions/month',
    ...options
});

/**
 * For Month
 *
 * Every open client's figures for one month, and who has none yet.
 */
export const monthlyReportsForMonth = <ThrowOnError extends boolean = false>(options: Options<MonthlyReportsForMonthData, ThrowOnError>): RequestResult<MonthlyReportsForMonthResponses, MonthlyReportsForMonthErrors, ThrowOnError> => (options.client ?? client).get<MonthlyReportsForMonthResponses, MonthlyReportsForMonthErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/monthly-reports',
    ...options
});

/**
 * Compute
 *
 * Work a closed month out now for every open client, from what the
 * platform holds today. The nightly job does the same on the 3rd.
 */
export const monthlyReportsCompute = <ThrowOnError extends boolean = false>(options: Options<MonthlyReportsComputeData, ThrowOnError>): RequestResult<MonthlyReportsComputeResponses, MonthlyReportsComputeErrors, ThrowOnError> => (options.client ?? client).post<MonthlyReportsComputeResponses, MonthlyReportsComputeErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/monthly-reports/compute',
    ...options
});

/**
 * Mine
 *
 * The caller's own org, latest month first.
 */
export const monthlyReportsMine = <ThrowOnError extends boolean = false>(options?: Options<MonthlyReportsMineData, ThrowOnError>): RequestResult<MonthlyReportsMineResponses, MonthlyReportsMineErrors, ThrowOnError> => (options?.client ?? client).get<MonthlyReportsMineResponses, MonthlyReportsMineErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/org/monthly-reports',
    ...options
});

/**
 * Actions
 */
export const auditActions = <ThrowOnError extends boolean = false>(options?: Options<AuditActionsData, ThrowOnError>): RequestResult<AuditActionsResponses, unknown, ThrowOnError> => (options?.client ?? client).get<AuditActionsResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/audit/actions',
    ...options
});

/**
 * List
 */
export const auditList = <ThrowOnError extends boolean = false>(options?: Options<AuditListData, ThrowOnError>): RequestResult<AuditListResponses, AuditListErrors, ThrowOnError> => (options?.client ?? client).get<AuditListResponses, AuditListErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/audit',
    ...options
});

/**
 * Export
 *
 * The matching entries as CSV, newest first, up to ten thousand.
 */
export const auditExport = <ThrowOnError extends boolean = false>(options?: Options<AuditExportData, ThrowOnError>): RequestResult<AuditExportResponses, AuditExportErrors, ThrowOnError> => (options?.client ?? client).get<AuditExportResponses, AuditExportErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/audit/export',
    ...options
});

/**
 * Mine
 *
 * A client's own org: what its manager and The Motherhood did to it.
 */
export const auditMine = <ThrowOnError extends boolean = false>(options?: Options<AuditMineData, ThrowOnError>): RequestResult<AuditMineResponses, AuditMineErrors, ThrowOnError> => (options?.client ?? client).get<AuditMineResponses, AuditMineErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/org/audit',
    ...options
});

/**
 * Get
 *
 * No login: the token is the permission, and it ends with the 90 days.
 */
export const downloadsGet = <ThrowOnError extends boolean = false>(options: Options<DownloadsGetData, ThrowOnError>): RequestResult<DownloadsGetResponses, DownloadsGetErrors, ThrowOnError> => (options.client ?? client).get<DownloadsGetResponses, DownloadsGetErrors, ThrowOnError>({ url: '/api/v1/downloads/{token}', ...options });

/**
 * File
 */
export const downloadsFile = <ThrowOnError extends boolean = false>(options: Options<DownloadsFileData, ThrowOnError>): RequestResult<unknown, DownloadsFileErrors, ThrowOnError> => (options.client ?? client).get<unknown, DownloadsFileErrors, ThrowOnError>({ url: '/api/v1/downloads/{token}/file', ...options });

/**
 * Email
 *
 * Bounces, so the Super Admin sees a download email that did not arrive.
 * Only removal downloads track delivery today; other events are ignored.
 */
export const webhooksEmail = <ThrowOnError extends boolean = false>(options?: Options<WebhooksEmailData, ThrowOnError>): RequestResult<WebhooksEmailResponses, WebhooksEmailErrors, ThrowOnError> => (options?.client ?? client).post<WebhooksEmailResponses, WebhooksEmailErrors, ThrowOnError>({ url: '/api/v1/webhooks/email', ...options });

/**
 * Counts
 */
export const notebookCounts = <ThrowOnError extends boolean = false>(options?: Options<NotebookCountsData, ThrowOnError>): RequestResult<NotebookCountsResponses, unknown, ThrowOnError> => (options?.client ?? client).get<NotebookCountsResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/me/notebook',
    ...options
});

/**
 * Pillars
 *
 * The org's content pillars, for tagging a post in Compose.
 */
export const notebookPillars = <ThrowOnError extends boolean = false>(options?: Options<NotebookPillarsData, ThrowOnError>): RequestResult<NotebookPillarsResponses, unknown, ThrowOnError> => (options?.client ?? client).get<NotebookPillarsResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/me/pillars',
    ...options
});

/**
 * Ideas
 *
 * Every suggestion, from moments and from each month's plan, newest first.
 */
export const notebookIdeas = <ThrowOnError extends boolean = false>(options?: Options<NotebookIdeasData, ThrowOnError>): RequestResult<NotebookIdeasResponses, NotebookIdeasErrors, ThrowOnError> => (options?.client ?? client).get<NotebookIdeasResponses, NotebookIdeasErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/me/ideas',
    ...options
});

/**
 * Updateidea
 */
export const notebookUpdateIdea = <ThrowOnError extends boolean = false>(options: Options<NotebookUpdateIdeaData, ThrowOnError>): RequestResult<NotebookUpdateIdeaResponses, NotebookUpdateIdeaErrors, ThrowOnError> => (options.client ?? client).patch<NotebookUpdateIdeaResponses, NotebookUpdateIdeaErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/me/ideas/{idea_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Archiveidea
 */
export const notebookArchiveIdea = <ThrowOnError extends boolean = false>(options: Options<NotebookArchiveIdeaData, ThrowOnError>): RequestResult<NotebookArchiveIdeaResponses, NotebookArchiveIdeaErrors, ThrowOnError> => (options.client ?? client).post<NotebookArchiveIdeaResponses, NotebookArchiveIdeaErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/me/ideas/{idea_id}/archive',
    ...options
});

/**
 * Restoreidea
 */
export const notebookRestoreIdea = <ThrowOnError extends boolean = false>(options: Options<NotebookRestoreIdeaData, ThrowOnError>): RequestResult<NotebookRestoreIdeaResponses, NotebookRestoreIdeaErrors, ThrowOnError> => (options.client ?? client).post<NotebookRestoreIdeaResponses, NotebookRestoreIdeaErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/me/ideas/{idea_id}/restore',
    ...options
});

/**
 * List
 *
 * Approved images in the org, newest first, a page at a time. `q`
 * matches the name or the description.
 */
export const assetsList = <ThrowOnError extends boolean = false>(options?: Options<AssetsListData, ThrowOnError>): RequestResult<AssetsListResponses, AssetsListErrors, ThrowOnError> => (options?.client ?? client).get<AssetsListResponses, AssetsListErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/assets',
    ...options
});

/**
 * Startupload
 *
 * A signed grant to send one image straight to storage. Confirm it after.
 */
export const assetsStartUpload = <ThrowOnError extends boolean = false>(options: Options<AssetsStartUploadData, ThrowOnError>): RequestResult<AssetsStartUploadResponses, AssetsStartUploadErrors, ThrowOnError> => (options.client ?? client).post<AssetsStartUploadResponses, AssetsStartUploadErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/assets/uploads',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Confirmupload
 *
 * The file has landed: check it with the store and show it to the org.
 */
export const assetsConfirmUpload = <ThrowOnError extends boolean = false>(options: Options<AssetsConfirmUploadData, ThrowOnError>): RequestResult<AssetsConfirmUploadResponses, AssetsConfirmUploadErrors, ThrowOnError> => (options.client ?? client).post<AssetsConfirmUploadResponses, AssetsConfirmUploadErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/assets/{asset_id}/confirm',
    ...options
});

/**
 * Delete
 *
 * Permanent. The file and the row go together.
 */
export const assetsDelete = <ThrowOnError extends boolean = false>(options: Options<AssetsDeleteData, ThrowOnError>): RequestResult<AssetsDeleteResponses, AssetsDeleteErrors, ThrowOnError> => (options.client ?? client).delete<AssetsDeleteResponses, AssetsDeleteErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/assets/{asset_id}',
    ...options
});

/**
 * Update
 */
export const assetsUpdate = <ThrowOnError extends boolean = false>(options: Options<AssetsUpdateData, ThrowOnError>): RequestResult<AssetsUpdateResponses, AssetsUpdateErrors, ThrowOnError> => (options.client ?? client).patch<AssetsUpdateResponses, AssetsUpdateErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/assets/{asset_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List
 */
export const activitiesList = <ThrowOnError extends boolean = false>(options?: Options<ActivitiesListData, ThrowOnError>): RequestResult<ActivitiesListResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ActivitiesListResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/activity-types',
    ...options
});

/**
 * Create
 *
 * Appears in every employee's picker immediately, this week included.
 */
export const activitiesCreate = <ThrowOnError extends boolean = false>(options: Options<ActivitiesCreateData, ThrowOnError>): RequestResult<ActivitiesCreateResponses, ActivitiesCreateErrors, ThrowOnError> => (options.client ?? client).post<ActivitiesCreateResponses, ActivitiesCreateErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/activity-types',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Reorder
 */
export const activitiesReorder = <ThrowOnError extends boolean = false>(options: Options<ActivitiesReorderData, ThrowOnError>): RequestResult<ActivitiesReorderResponses, ActivitiesReorderErrors, ThrowOnError> => (options.client ?? client).put<ActivitiesReorderResponses, ActivitiesReorderErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/activity-types/order',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete
 *
 * Out of the picker for future weeks. Weeks already using it keep it.
 */
export const activitiesDelete = <ThrowOnError extends boolean = false>(options: Options<ActivitiesDeleteData, ThrowOnError>): RequestResult<ActivitiesDeleteResponses, ActivitiesDeleteErrors, ThrowOnError> => (options.client ?? client).delete<ActivitiesDeleteResponses, ActivitiesDeleteErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/activity-types/{type_id}',
    ...options
});

/**
 * Update
 *
 * The new words apply everywhere the activity already appears.
 */
export const activitiesUpdate = <ThrowOnError extends boolean = false>(options: Options<ActivitiesUpdateData, ThrowOnError>): RequestResult<ActivitiesUpdateResponses, ActivitiesUpdateErrors, ThrowOnError> => (options.client ?? client).patch<ActivitiesUpdateResponses, ActivitiesUpdateErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/activity-types/{type_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get
 */
export const trackerGet = <ThrowOnError extends boolean = false>(options?: Options<TrackerGetData, ThrowOnError>): RequestResult<TrackerGetResponses, unknown, ThrowOnError> => (options?.client ?? client).get<TrackerGetResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/me/tracker',
    ...options
});

/**
 * Updatesettings
 */
export const trackerUpdateSettings = <ThrowOnError extends boolean = false>(options: Options<TrackerUpdateSettingsData, ThrowOnError>): RequestResult<TrackerUpdateSettingsResponses, TrackerUpdateSettingsErrors, ThrowOnError> => (options.client ?? client).put<TrackerUpdateSettingsResponses, TrackerUpdateSettingsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/me/tracker/settings',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Pick
 *
 * Pick an activity for this week, or one more of one already picked.
 */
export const trackerPick = <ThrowOnError extends boolean = false>(options: Options<TrackerPickData, ThrowOnError>): RequestResult<TrackerPickResponses, TrackerPickErrors, ThrowOnError> => (options.client ?? client).post<TrackerPickResponses, TrackerPickErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/me/tracker/picks',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Less
 */
export const trackerLess = <ThrowOnError extends boolean = false>(options: Options<TrackerLessData, ThrowOnError>): RequestResult<TrackerLessResponses, TrackerLessErrors, ThrowOnError> => (options.client ?? client).post<TrackerLessResponses, TrackerLessErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/me/tracker/picks/{pick_id}/less',
    ...options
});

/**
 * Tap
 */
export const trackerTap = <ThrowOnError extends boolean = false>(options: Options<TrackerTapData, ThrowOnError>): RequestResult<TrackerTapResponses, TrackerTapErrors, ThrowOnError> => (options.client ?? client).post<TrackerTapResponses, TrackerTapErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/me/tracker/picks/{pick_id}/tap',
    ...options
});

/**
 * Undo
 */
export const trackerUndo = <ThrowOnError extends boolean = false>(options: Options<TrackerUndoData, ThrowOnError>): RequestResult<TrackerUndoResponses, TrackerUndoErrors, ThrowOnError> => (options.client ?? client).post<TrackerUndoResponses, TrackerUndoErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/me/tracker/picks/{pick_id}/undo',
    ...options
});

/**
 * History
 *
 * Past weeks, newest first, read-only.
 */
export const trackerHistory = <ThrowOnError extends boolean = false>(options?: Options<TrackerHistoryData, ThrowOnError>): RequestResult<TrackerHistoryResponses, unknown, ThrowOnError> => (options?.client ?? client).get<TrackerHistoryResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/me/tracker/history',
    ...options
});

/**
 * Postingsummary
 *
 * How the team is posting. Counts and public reactions, no names, no text.
 */
export const draftsPostingSummary = <ThrowOnError extends boolean = false>(options?: Options<DraftsPostingSummaryData, ThrowOnError>): RequestResult<DraftsPostingSummaryResponses, DraftsPostingSummaryErrors, ThrowOnError> => (options?.client ?? client).get<DraftsPostingSummaryResponses, DraftsPostingSummaryErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/team/posting-summary',
    ...options
});

/**
 * List
 */
export const draftsList = <ThrowOnError extends boolean = false>(options?: Options<DraftsListData, ThrowOnError>): RequestResult<DraftsListResponses, unknown, ThrowOnError> => (options?.client ?? client).get<DraftsListResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/me/drafts',
    ...options
});

/**
 * Create
 */
export const draftsCreate = <ThrowOnError extends boolean = false>(options: Options<DraftsCreateData, ThrowOnError>): RequestResult<DraftsCreateResponses, DraftsCreateErrors, ThrowOnError> => (options.client ?? client).post<DraftsCreateResponses, DraftsCreateErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/me/drafts',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete
 */
export const draftsDelete = <ThrowOnError extends boolean = false>(options: Options<DraftsDeleteData, ThrowOnError>): RequestResult<DraftsDeleteResponses, DraftsDeleteErrors, ThrowOnError> => (options.client ?? client).delete<DraftsDeleteResponses, DraftsDeleteErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/me/drafts/{draft_id}',
    ...options
});

/**
 * Get
 */
export const draftsGet = <ThrowOnError extends boolean = false>(options: Options<DraftsGetData, ThrowOnError>): RequestResult<DraftsGetResponses, DraftsGetErrors, ThrowOnError> => (options.client ?? client).get<DraftsGetResponses, DraftsGetErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/me/drafts/{draft_id}',
    ...options
});

/**
 * Update
 */
export const draftsUpdate = <ThrowOnError extends boolean = false>(options: Options<DraftsUpdateData, ThrowOnError>): RequestResult<DraftsUpdateResponses, DraftsUpdateErrors, ThrowOnError> => (options.client ?? client).patch<DraftsUpdateResponses, DraftsUpdateErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/me/drafts/{draft_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * History
 *
 * One post's full reading history, for its own chart. Bounded to this post,
 * so it never grows with the org's or the platform's total history.
 */
export const draftsHistory = <ThrowOnError extends boolean = false>(options: Options<DraftsHistoryData, ThrowOnError>): RequestResult<DraftsHistoryResponses, DraftsHistoryErrors, ThrowOnError> => (options.client ?? client).get<DraftsHistoryResponses, DraftsHistoryErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/me/drafts/{draft_id}/history',
    ...options
});

/**
 * Previewpost
 *
 * Read the pasted link and show what we found, without recording it yet.
 *
 * This is the confirm step: the person sees the real author and text and can
 * tell at a glance whether the link is right. Nothing is marked posted here.
 */
export const draftsPreviewPost = <ThrowOnError extends boolean = false>(options: Options<DraftsPreviewPostData, ThrowOnError>): RequestResult<DraftsPreviewPostResponses, DraftsPreviewPostErrors, ThrowOnError> => (options.client ?? client).post<DraftsPreviewPostResponses, DraftsPreviewPostErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/me/drafts/{draft_id}/preview',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Confirmposted
 *
 * Yes, that is the post. Commit it; the previewed reading becomes the first
 * snapshot and the daily-then-weekly schedule starts. No second fetch.
 */
export const draftsConfirmPosted = <ThrowOnError extends boolean = false>(options: Options<DraftsConfirmPostedData, ThrowOnError>): RequestResult<DraftsConfirmPostedResponses, DraftsConfirmPostedErrors, ThrowOnError> => (options.client ?? client).post<DraftsConfirmPostedResponses, DraftsConfirmPostedErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/me/drafts/{draft_id}/confirm-posted',
    ...options
});

/**
 * Discardpreview
 *
 * Not the right post. Throw the look away and go back to editing.
 */
export const draftsDiscardPreview = <ThrowOnError extends boolean = false>(options: Options<DraftsDiscardPreviewData, ThrowOnError>): RequestResult<DraftsDiscardPreviewResponses, DraftsDiscardPreviewErrors, ThrowOnError> => (options.client ?? client).post<DraftsDiscardPreviewResponses, DraftsDiscardPreviewErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/me/drafts/{draft_id}/discard-preview',
    ...options
});

/**
 * Growth
 */
export const draftsGrowth = <ThrowOnError extends boolean = false>(options?: Options<DraftsGrowthData, ThrowOnError>): RequestResult<DraftsGrowthResponses, unknown, ThrowOnError> => (options?.client ?? client).get<DraftsGrowthResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/me/drafts/growth/me',
    ...options
});

/**
 * Orgreport
 *
 * One org's posting: KPIs, a line per teammate, and a six-month trend.
 */
export const analyticsOrgReport = <ThrowOnError extends boolean = false>(options?: Options<AnalyticsOrgReportData, ThrowOnError>): RequestResult<AnalyticsOrgReportResponses, AnalyticsOrgReportErrors, ThrowOnError> => (options?.client ?? client).get<AnalyticsOrgReportResponses, AnalyticsOrgReportErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/team/analytics',
    ...options
});

/**
 * Crossorgreport
 *
 * Every client org rolled up: totals, a line per org, and a six-month trend.
 */
export const analyticsCrossOrgReport = <ThrowOnError extends boolean = false>(options?: Options<AnalyticsCrossOrgReportData, ThrowOnError>): RequestResult<AnalyticsCrossOrgReportResponses, AnalyticsCrossOrgReportErrors, ThrowOnError> => (options?.client ?? client).get<AnalyticsCrossOrgReportResponses, AnalyticsCrossOrgReportErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/analytics',
    ...options
});

/**
 * Disconnect
 *
 * Stop acting for the pages and forget the keys. Every page's stats stay.
 */
export const socialPageDisconnect = <ThrowOnError extends boolean = false>(options?: Options<SocialPageDisconnectData, ThrowOnError>): RequestResult<SocialPageDisconnectResponses, SocialPageDisconnectErrors, ThrowOnError> => (options?.client ?? client).delete<SocialPageDisconnectResponses, SocialPageDisconnectErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/org/page',
    ...options
});

/**
 * Status
 *
 * Whether the pages are connected, as whom, and anything that went wrong.
 */
export const socialPageStatus = <ThrowOnError extends boolean = false>(options?: Options<SocialPageStatusData, ThrowOnError>): RequestResult<SocialPageStatusResponses, SocialPageStatusErrors, ThrowOnError> => (options?.client ?? client).get<SocialPageStatusResponses, SocialPageStatusErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/org/page',
    ...options
});

/**
 * Connect
 *
 * Where to send the SMM to approve access to their pages.
 */
export const socialPageConnect = <ThrowOnError extends boolean = false>(options?: Options<SocialPageConnectData, ThrowOnError>): RequestResult<SocialPageConnectResponses, SocialPageConnectErrors, ThrowOnError> => (options?.client ?? client).post<SocialPageConnectResponses, SocialPageConnectErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/org/page/connect',
    ...options
});

/**
 * Refreshpages
 *
 * Ask the vendor again which pages the account runs.
 */
export const socialPageRefreshPages = <ThrowOnError extends boolean = false>(options?: Options<SocialPageRefreshPagesData, ThrowOnError>): RequestResult<SocialPageRefreshPagesResponses, SocialPageRefreshPagesErrors, ThrowOnError> => (options?.client ?? client).post<SocialPageRefreshPagesResponses, SocialPageRefreshPagesErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/org/page/pages/refresh',
    ...options
});

/**
 * Selectpages
 *
 * Which of the listed pages to track. Nothing is deleted either way.
 */
export const socialPageSelectPages = <ThrowOnError extends boolean = false>(options: Options<SocialPageSelectPagesData, ThrowOnError>): RequestResult<SocialPageSelectPagesResponses, SocialPageSelectPagesErrors, ThrowOnError> => (options.client ?? client).put<SocialPageSelectPagesResponses, SocialPageSelectPagesErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/org/page/pages/selection',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Setprimary
 *
 * Make this the page the org means by default. Nothing is deleted.
 */
export const socialPageSetPrimary = <ThrowOnError extends boolean = false>(options: Options<SocialPageSetPrimaryData, ThrowOnError>): RequestResult<SocialPageSetPrimaryResponses, SocialPageSetPrimaryErrors, ThrowOnError> => (options.client ?? client).post<SocialPageSetPrimaryResponses, SocialPageSetPrimaryErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/org/page/pages/{connection_id}/primary',
    ...options
});

/**
 * Sync
 *
 * Fetch now rather than waiting for tonight. The same work the job does,
 * rate limited because the vendor meters the admin's token by the day.
 */
export const socialPageSync = <ThrowOnError extends boolean = false>(options?: Options<SocialPageSyncData, ThrowOnError>): RequestResult<SocialPageSyncResponses, SocialPageSyncErrors, ThrowOnError> => (options?.client ?? client).post<SocialPageSyncResponses, SocialPageSyncErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/org/page/sync',
    ...options
});

/**
 * Posthistory
 *
 * One page post's readings over time, for its own chart.
 */
export const socialPagePostHistory = <ThrowOnError extends boolean = false>(options: Options<SocialPagePostHistoryData, ThrowOnError>): RequestResult<SocialPagePostHistoryResponses, SocialPagePostHistoryErrors, ThrowOnError> => (options.client ?? client).get<SocialPagePostHistoryResponses, SocialPagePostHistoryErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/org/page/posts/{post_id}/history',
    ...options
});

/**
 * Analytics
 *
 * How a page did: totals, a trend, and the posts that carried it. The
 * primary page unless one is named.
 */
export const socialPageAnalytics = <ThrowOnError extends boolean = false>(options?: Options<SocialPageAnalyticsData, ThrowOnError>): RequestResult<SocialPageAnalyticsResponses, SocialPageAnalyticsErrors, ThrowOnError> => (options?.client ?? client).get<SocialPageAnalyticsResponses, SocialPageAnalyticsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/org/page/analytics',
    ...options
});

/**
 * Publishpost
 *
 * Put a planned post on a page, now: the named one, or the primary.
 */
export const socialPagePublishPost = <ThrowOnError extends boolean = false>(options: Options<SocialPagePublishPostData, ThrowOnError>): RequestResult<SocialPagePublishPostResponses, SocialPagePublishPostErrors, ThrowOnError> => (options.client ?? client).post<SocialPagePublishPostResponses, SocialPagePublishPostErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/org/page/posts/{post_id}/publish',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Health
 *
 * Worker, scheduled jobs, work that has fallen behind, and recent failures.
 */
export const systemHealth = <ThrowOnError extends boolean = false>(options?: Options<SystemHealthData, ThrowOnError>): RequestResult<SystemHealthResponses, unknown, ThrowOnError> => (options?.client ?? client).get<SystemHealthResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/system/health',
    ...options
});

/**
 * Errors
 *
 * Every recorded error, newest first, with its traceback and context.
 */
export const systemErrors = <ThrowOnError extends boolean = false>(options?: Options<SystemErrorsData, ThrowOnError>): RequestResult<SystemErrorsResponses, SystemErrorsErrors, ThrowOnError> => (options?.client ?? client).get<SystemErrorsResponses, SystemErrorsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/system/errors',
    ...options
});

/**
 * Report
 *
 * The browser met an error. Kept like any other, marked as from the web,
 * with who was signed in and where they were. Limited per person, because
 * a page stuck in a loop must not fill the table.
 */
export const systemReport = <ThrowOnError extends boolean = false>(options: Options<SystemReportData, ThrowOnError>): RequestResult<SystemReportResponses, SystemReportErrors, ThrowOnError> => (options.client ?? client).post<SystemReportResponses, SystemReportErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/client-errors',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
